<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-5
      .col
        router-link.button-previous.mr-2(to="/dialogo-desempeno/id")
          i.fas.fa-chevron-left
        h2.m-0.d-inline-block.align-middle
          i {{$route.name}}
      .col-auto.text-right
        h3.m-0
          | {{meeting ? meeting.date_scheduled : '' | DateFormat}}
    section
      .d-flex.row.flex-row.align-items-end
        .col
          h3 
            i Descripción del diálogo de desempeño
        .col-auto
          h3
            span.ml-4.ad_text-grayClaro.text-thin {{meeting ? meeting.description : ''}}
      .d-flex.row.flex-row.mt-4
        .col-5
          .card.ad_border1-secondary.rounded-xl
            h4 
              i Asistentes
            .row
              .col-12
                form
                  multiselect(
                    v-model="colaboradores",
                    :options="todosLosColaboradores",
                    :multiple="true",
                    :close-on-select="false",
                    :clear-on-select="false",
                    :preserve-search="true",
                    placeholder="Seleccione...",
                    label="name",
                    track-by="_id",
                    :preselect-first="false"
                  )
                p.mt-3.mb-0
                  i.ad_text-success(v-if="colaboradores && colaboradores.length > 0") Asistentes {{ colaboradores.length }}

        .col-7
          .card.ad_border1-secondary.rounded-xl
            h4 
              i Objetivos
            .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(objective, index) in meeting.objectives" :key="objective.id")
              form
                .d-flex.row.form-group.align-items-end.mb-1
                  .col
                    label
                      a(:id="'viaje' + index")
                        i.icon-letters.icon-letters__viaje(v-if="objective.travel") V
                        i.icon-letters.icon-letters__producto.mx-1(v-if="objective.product") P
                        i.icon-letters.icon-letters__segmento(v-if="objective.segment") S
                      b-tooltip(:target="'viaje' + index" , placement='top')
                        | {{objective.travel ? objective.travel.name : ' '}} + {{objective.product ? objective.product.name : ' '}} + {{objective.segment ? objective.segment.name : ' '}}
                    label.ml-2
                      i.icon-letters.icon-letters__negocio.mr-1 N
                      | {{objective.business_type ? objective.business_type.name : ''}}
                  .col-auto
                    p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
                      sup Registro
                      span {{objective.businesspercentage}}%
                    p.d-inline-block.mb-0.ad_text-grayMedio
                      sup Meta
                      span {{objective.kpi ? objective.kpi.goal : ''}}%
              .d-flex.row
                .col-12
                  table.w-100.text-center.table-rounded-body
                    thead
                      tr
                        th
                        th.text-left Objetivo
                        th
                        th 
                        th Registro
                        th Meta
                        th
                    tbody
                      tr
                        td
                          div
                            span.num_circle.ad_bg-secondary {{index + 1}}
                        td.text-left
                          div
                            | {{objective.kpi ? objective.kpi.name : ''}}
                        td
                          div
                            span.ad_text-success
                              | {{objective.date | WeekDuration}}&deg; sem
                        td
                          div.pr-0.justify-content-center.text-info
                            | {{objective.open ? "Libre" : ""}}
                        td
                          div
                            | {{objective.kpipercentage}}%
                        td
                          div
                            | {{objective.kpi ? objective.kpi.goal : ''}}%
                        td
                          div
                            a.no-decoration(title="Comentarios" @click='openObjectiveCommentBox(objective)')
                              i.icono.icono-comentarios.ad_text-primary
        .col-12
          .open-cards.card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !compromiso}")
            .row.d-flex.align-items-center
              .col
                h4.m-0.ad_text-primary
                  i Compromisos equipo 
              .col-auto
                button.no-decoration.p-0(@click="compromiso = !compromiso" :class="{'chevron-up' : !compromiso}")
                  span.ad_text-primary.font-weight-bold.font-italic Ver
                    em(v-if="!compromiso")  menos
                    em(v-if="compromiso")  más
                  i.fas.fa-chevron-down.ad_text-primary.align-middle.ml-1
            .row.d-flex.align-items-center
              .col-auto
                label.m-0 Nuevo
              .col.px-1
                input.form-control(v-model="commitment.description" type="text" placeholder="Descripción")
              .col.px-1
                multiselect(
                  v-model="commitment.user",
                  :options="dddColaboradores",
                  :multiple="true",
                  :searchable="false",
                  :close-on-select="false",
                  :show-labels="false"
                  placeholder="Responsable"
                  label="name",
                  track-by="_id",
                  @input="isTodos(commitment)"
                )
              .col.px-1
                multiselect(
                  v-model="commitment.objective",
                  :options="objectives",
                  :close-on-select="true",
                  placeholder="Objetivo",
                  :custom-label="customKpiLabel",
                  track-by="_id"
                )
              .col.px-1.position-relative
                v-menu(ref='menu', v-model='menu', :close-on-content-click='false', :nudge-right='40', :return-value.sync='date', lazy, transition='scale-transition', offset-y='', full-width, min-width='290px')
                  v-text-field.date-input(slot='activator', v-model='commitment.date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='commitment.date', no-title='', scrollable='' locale="es", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="addCommitmentToCollab()")
                  i.fas.fa-plus.rounded-circle
                
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : compromiso}")
            .card-body
              .row
                .col
                  h3 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="allCommitments.pendientes == ''")
                    | Aún no tienes compromisos pendientes
                  table.w-100.text-left.table-rounded-body(v-if="allCommitments.pendientes != ''")
                    thead
                      tr
                        th Responsable/es
                        th Descripción
                        th Objetivo
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th Antigüedad
                        th
                        th
                    tbody
                      tr(v-for="pcommitment in allCommitments.pendientes")
                        td
                          div
                            | {{ pcommitment | Responsibles(pcommitment) }}
                        td
                          div.py-2
                            | {{ pcommitment.description }}
                        td
                          .d-flex.flex-nowrap
                            i.icono.icono-objetivos.align-top.ad_text-primary.mr-2
                            | {{ pcommitment.objective.kpi ? pcommitment.objective.kpi : '' }}
                        td
                          div
                            | {{moment(pcommitment.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(pcommitment.scheduled).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-danger
                              | {{ moment().format('W') - moment(pcommitment.date).format('W')  }}&deg; sem
                        td
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(pcommitment._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div
                            a.btn.btn-secondary.text-Lhite.px-3(@click="openCloseModal(pcommitment._id, 'commitment', pcommitment)")
                              | Cerrar                  
              .row.mt-4
                .col
                  h3 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="allCommitments.nuevos == ''")
                    | Aún no tienes compromisos nuevos
                  table.w-100.text-left.table-rounded-body(v-if="allCommitments.nuevos != ''")
                    thead
                      tr
                        th Responsable/es
                        th Descripción
                        th Objetivo
                        th Fecha de ingreso
                        th Fecha de Compromiso
                        th
                        th
                    tbody
                      tr(v-for="(ncommitment, n) in allCommitments.nuevos")
                        td
                          div
                            | {{ ncommitment | Responsibles(ncommitment) }}
                        td
                          div.py-2
                            | {{ ncommitment.description }}
                        td
                          div
                            i.icono.icono-objetivos.align-top.ad_text-primary.mr-2
                            //.-span.mr-1(v-for="objetive in ncommitment.objective")
                            | {{ ncommitment.objective.kpi ? ncommitment.objective.kpi : '' }}
                        td
                          div
                            | {{moment(ncommitment.date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            | {{moment(ncommitment.scheduled).utc().format("DD/MM/YYYY")}}
                        td(width="50")
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(ncommitment._id, 'commitment')")
                              i.icono.icono-comentarios.ad_text-primary
                        td(width="50")
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(:id="'compromiso' + n" @click="removeCommit('nuevos', ncommitment.id)")
                              i.fas.fa-times.rounded-circle.text-white
                            b-tooltip(:target="'compromiso' + n" , placement='top') 
                              | Eliminar Compromiso

        .col-12
          .open-cards.card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !problemas}")
            .row.mb-2.d-flex.align-items-center
              .col
                h4.m-0.ad_text-primary
                  i Problemas & Oportunidades 
              .col-auto
                button.no-decoration.p-0(@click="problemas = !problemas" :class="{'chevron-up' : !problemas}")
                  span.ad_text-primary.font-weight-bold.font-italic Ver
                    em(v-if="!problemas")  menos
                    em(v-if="problemas")  más
                  i.fas.fa-chevron-down.ad_text-primary.align-middle.ml-1
            .row.d-flex.align-items-center
              .col-auto
                label.m-0 Nuevo
              .col.px-1
                input.form-control(v-model="problemsAndOportunities.description" type="text" placeholder="Descripción")
              .col.px-1
                multiselect(
                  v-model="problemsAndOportunities.observer",
                  :options="colaboradores",
                  :searchable="false",
                  :close-on-select="true",
                  :show-labels="false"
                  placeholder="Observador"
                  label="name",
                  track-by="_id"
                )
              .col.px-1
                multiselect(
                  v-model="problemsAndOportunities.responsible",
                  :options="colaboradores",
                  :searchable="false",
                  :close-on-select="true",
                  :show-labels="false"
                  placeholder="Responsable"
                  label="name",
                  track-by="_id"
                )
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="newProblem()")
                  i.fas.fa-plus.rounded-circle
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : problemas}")
            .card-body
              .row
                .col
                  h3 
                    i Pendientes
                  p.text-center.ad_text-grayLight.font-italic(v-if="listProblemsAndOport.pendientes == ''")
                    | Aún no tienes Problemas & Oportunidades pendientes
                  table.w-100.text-left.table-rounded-body(v-if="listProblemsAndOport.pendientes != ''")
                    thead
                      tr
                        th Observador
                        th Descripción
                        th Responsable
                        th Fecha de ingreso
                        th Semestre
                        th
                        th
                    tbody
                      tr(v-for="op in listProblemsAndOport.pendientes")
                        td
                          div
                            | {{ op.observer.name }}
                        td
                          div.py-2
                            | {{ op.description }}
                        td
                          div
                            | {{ op.responsible.name }}
                        td
                          div
                            | {{moment(op.creation_date).utc().format("DD/MM/YYYY")}}
                        td
                          div
                            span.ad_text-success(v-if="moment() < moment(op.creation_date)")
                              | {{ moment().format('W') - moment(op.creation_date).format('W') === 0 ? 1 : moment(op.creation_date).format('W') }}&deg; sem
                            span.ad_text-warning(v-if="moment() === moment(op.creation_date)")
                              | {{ moment().format('W') - moment(op.creation_date).format('W')  }}&deg; sem
                            span.ad_text-danger(v-if="moment() > moment(op.creation_date)")
                              | {{ moment().format('W') - moment(op.creation_date).format('W') }}&deg; sem
                        td(width="50")
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(op._id, 'problem')")
                              i.icono.icono-comentarios.ad_text-primary
                        td(width="50")
                          div
                            a.btn.btn-secondary.px-3(@click="openCloseModal(op._id, 'problem', op)")
                              | Cerrar
              .row.mt-4
                .col
                  h3 
                    i Nuevos
                  p.text-center.ad_text-grayLight.font-italic(v-if="listProblemsAndOport.nuevos == ''")
                    | Aún no tienes Problemas & Oportunidades nuevos
                  table.w-100.text-left.table-rounded-body(v-if="listProblemsAndOport.nuevos != ''")
                    thead
                      tr
                        th Observador
                        th Descripción
                        th Responsable
                        th
                        th
                    tbody
                      tr
                      tr(v-for="(op, n) in listProblemsAndOport.nuevos")
                        td
                          div
                            | {{ op.observer.name }}
                        td
                          div.py-2
                            | {{ op.description }}
                        td
                          div
                            | {{ op.responsible.name }}
                        td.text-right(width="50")
                          div
                            a.no-decoration(title="Comentarios" @click="getComments(op._id, 'problem')")
                              i.icono.icono-comentarios.ad_text-primary
                        td.text-right(width="50")
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(:id="'problemas' + n" @click="removeProblem('nuevos', op._id)")
                              i.fas.fa-times.rounded-circle.text-white
                            b-tooltip(:target="'problemas' + n" , placement='top') 
                              | Eliminar Problema & Oportunidad
        .col-12
          .open-cards.card.ad_border1-secondary.rounded-xl.mb-0.mt-4.position-relative(:class="{'off-position' : !otros}")
            .row.mb-2.d-flex.align-items-center
              .col
                h4.m-0.ad_text-primary
                  i Otros temas 
              .col-auto
                button.no-decoration.p-0(@click="otros = !otros" :class="{'chevron-up' : !otros}")
                  span.ad_text-primary.font-weight-bold.font-italic Ver
                    em(v-if="!otros")  menos
                    em(v-if="otros")  más
                  i.fas.fa-chevron-down.ad_text-primary.align-middle.ml-1
            .row.d-flex.align-items-center
              .col-auto
                label.m-0 Nuevo 
              .col.px-1
                input.form-control(v-model="theme.issue" type="text" placeholder="Asunto")
              .col.px-1
                input.form-control(v-model="theme.description" type="text" placeholder="Descripción")
              .col-auto
                button.ad_bg-success.btn-icon(type="button", @click="createTheme()")
                  i.fas.fa-plus.rounded-circle
          
          .col.collapsible.ad_bg-gray.px-0.mt--3(:class="{'collapsed' : otros}")
            .card-body
              .row
                .col
                  p.text-center.ad_text-grayLight.font-italic(v-if="allThemes == ''")
                    | Aún no tienes Otros Temas nuevos
                  table.w-100.text-left.table-rounded-body(v-if="allThemes != ''")
                    thead
                      tr
                        th Asunto
                        th Descripción
                        th
                    tbody
                      tr(v-for="(theme, n) in allThemes")
                        td
                          div
                            | {{ theme.issue }}
                        td
                          div.py-2
                            | {{ theme.description }}
                        td.text-right(width="50")
                          div
                            a.btn-icon.ad_bg-secondary.border-btnicon-secondary(:id="'otros' + n" @click="removeTheme(theme._id)")
                              i.fas.fa-times.rounded-circle.text-white
                            b-tooltip(:target="'otros' + n" , placement='top') 
                              | Eliminar Tema
      .d-flex.row.flex-row.mt-4
        .col-12.text-right
          button.btn.btn-primary.py-2.px-5(@click="closeDDD()")
            em Finalizar_
            
    v-navigation-drawer(v-model='drawer_objective', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col
          label
            i.icon-letters.icon-letters__viaje.mr-1(v-if="objective.travel") S
            i.icon-letters.icon-letters__kpi.mr-1(v-if="objective.product") P
            | {{ `${objective.travel ? objective.travel.name + '/' : ''}${objective.product ? objective.product.name + '/': ''}${objective.segment ? objective.segment.name : ''}` }}
          label
            i.icon-letters.icon-letters__negocio.mr-1 N
            | {{ objective.business_type ? objective.business_type.name : '' }}
        .row.align-items-end
          .col
            .col-12
              h4 {{ objective.kpi ? objective.kpi.name : ''}}
          .col-auto.pr-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Registro
              span {{ objective.kpipercentage }}%
            p.d-inline-block.mb-0.ad_text-grayMedio
              sup Meta
              span {{ objective.kpi ? objective.kpi.goal : '' }}%
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
          .form-group.justify-content-between
            button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer_objective=false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addObjectiveComment(objective.id)")
              | Agregar comentario
              i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          div(v-if="objective")        
            .row.mb-3(v-for='comm in objective.comments')
              .col-4.pr-0(v-if="comm != null")
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{moment(comm.date) | DateFormat}}
                small.d-block {{moment(comm.date) | HourFormat}} hrs.
              .col-8.pl-0(v-if="comm != null")
                .dialog-box
                  p {{comm.text}}  

    v-navigation-drawer(v-model='commenting', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="commenting=false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="createComment(comment)")
            | Agregar comentario
            i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-3
          i Anteriores
        div(v-if="comments")        
          .row.mb-3(v-for='comm in comments')
            .col-4.pr-0(v-if="comm != null")
              p.font-weight-bold.m-0 {{comm.user}}
              small.d-block {{moment(comm.creation_date) | DateFormat}}
              small.d-block {{moment(comm.creation_date) | HourFormat}} hrs.
            .col-8.pl-0(v-if="comm != null")
              .dialog-box
                p {{comm.description}}  

  v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Cerrar Compromiso Colaborador
    section.py-4.px-2.overflowy-auto
      .col.d-flex.flex-nowrap
        p {{ item.description }}
      .d-flex.flex-row
        .col-5
          c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
          c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="closeItem()")
            | Cerrar compromisos
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-3
          i Comentarios
        div(v-if="comments")        
          .row.mb-3(v-for='comm in comments')
            .col-4.pr-0(v-if="comm != null")
              p.font-weight-bold.m-0 {{comm.user}}
              small.d-block {{moment(comm.creation_date) | DateFormat}}
              small.d-block {{moment(comm.creation_date) | HourFormat}} hrs.
            .col-8.pl-0(v-if="comm != null")
              .dialog-box
                p {{comm.description}}  

      
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment-timezone'
import Flatpickr from 'vendors/cover/vendors/flatpickr'
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

export default {

  name: 'DialogoDesempenoEjecutar',
  components: {
     Multiselect,
     Flatpickr
  },
  data () {
    return {
      menu: false,
      date: null,
      user: {},
      accountable: null,
      commenting: null,
      commitment: {},
      commitments: [],
      pcommitments: [],
      tracing: null,
      compromiso: false,
      problemas: false,
      otros: false,
      responsable: '',
      observador: '',
      objective: { travel: { name: '' }, product: { name: '' }, segment: { name: '' }, business_type: { name: '' }, kpi: { name: '', goal: '' }, comments: [] } ,
      objectives: [],
      asistentes: [],
      colaboradores: [],
      dddColaboradores: [{_id: null, name: 'Todos'}],
      todosLosColaboradores: [],
      comment: null,
      allCommitments: { nuevos: [], pendientes: [] },
      problemsAndOportunities: {},
      listProblemsAndOport: { nuevos: [], pendientes: [] },
      theme: {},
      allThemes: [],
      ncommitments: null,
      meeting: {},
      comments: [],
      closing: null,
      type: null,
      cumplimiento: '',
      drawer: null,
      drawer_objective: null,
      item: { description: '' }
    }
  },
  computed: {
    // ...mapGetters('user', {collabs: 'getMyCollabs'}),
    // ...mapGetters('meeting', { meet: 'getMeeting'})
  },
  methods: {
    moment,
    ...mapActions('objective', [
      'getObjectiveByPlan',
      'addComment'
      ]),
    ...mapActions('tracing', [
      'getTracingByPlan', 
      'createProblemOrOportunity', 
      'deleteProblem',
      ]),
    ...mapActions('user', ['myCollabs']),
    ...mapActions('meeting', [
      'getMeetingById', 
      'newTheme', 
      'listCommitments', 
      'listProblems', 
      'listThemes', 
      'deleteTheme',
      'finishMeeting'
      ]),
    ...mapActions('travel', ['travelList']),
    ...mapActions('commitment', [
      'createCommitment',
      'getCommitmentsByTracing',
      'getPendingCommitmentsByTeam',
      'getCommitmentByWeek',
      'deleteCommitment',
      'addCommentToCommitment', 
      'getCommentsFromCommitment',
      'closeCommitment'
    ]),
    ...mapActions('problem', [
      'addCommentToProblem', 
      'getCommentsFromProblem',
      'closeProblem'
    ]),
    loadMeeting(meetingId) {
      const vm = this
      const loading = vm.$toast.loading('Cargando DDD...')
      vm.getMeetingById(meetingId)
      .then(meeting => {
        vm.meeting = meeting
        vm.objectives = meeting.objectives
      }, error => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    loadObjetives(planId) {
      const vm = this
      const loading = vm.$toast.loading('Cargando objetivos...')
      vm.getObjectiveByPlan(planId).then(() => {
        vm.objectivesByPlan = vm.$store.getters['objective/getObjectivesByPlan']
      }, error => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    loadCollabs(userId) {
      const vm = this
      vm.myCollabs(vm.user.id).then(collabs => {
        // console.table(collabs)
        vm.todosLosColaboradores = collabs;
        vm.colaboradores = collabs;
        vm.dddColaboradores = vm.dddColaboradores.concat(collabs);
      })
    },
    addCommitmentToCollab() {
      const vm = this
      let { description, date, objective, user } = vm.commitment
      if (description && date && objective && user) {
        vm.meeting.objectives.forEach(obj => {
          if (obj.id === objective.id) {
            const { travel, segment, product } = objective
            objective = {
              S: `${travel ? travel.name : ' '}-${segment ? segment.name : ' '}-${product ? product.name : ' '}`,
              P: objective.business_type ? objective.business_type.name : '',
              id: obj.id
            }
          }
        })
        const payload = { 
          meeting: vm.$route.params.id,
          date: new Date(moment()),
          objective,
          scheduled: date,
          description,
          user: user,
          created_by: vm.user.id
        }
        vm.createCommitment(payload).then(response => {
          if (response._id) {
            vm.commitment.description = ''
            vm.commitment.date = ''
            vm.commitment.user = null
            vm.commitment.objective = null
            vm.listCommitments(vm.$store.state.auth.user.id).then(response => {
              vm.allCommitments = response.commitments
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso de colaborador creado',
              closeable: true,
              duration: 5000
            })
          }
        }, error => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    newProblem() {
      const vm = this;
      let { responsible, observer, description } = vm.problemsAndOportunities
      const data = {
        user: vm.user.id_usuario,
        meeting: vm.$route.params.id,
        description,
        responsible,
        observer,
        type: 'all'
      }
      if (responsible && observer && description) {
        vm.createProblemOrOportunity(data).then(result => {
          if (result._id) {
            vm.listProblemsAndOport.nuevos.push(result)
            vm.problemsAndOportunities.description = ''
            vm.problemsAndOportunities.responsible = ''
            vm.problemsAndOportunities.observer = ''
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Nuevo problema/oportunidad creado',
              closeable: true,
              duration: 5000
            })
          }
        }, error => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    createTheme() {
      const vm = this;
      const { description, issue } = vm.theme
      if (description && issue) {
        const data = {
          user: vm.user.id,
          description, 
          issue,
          meeting: vm.$route.params.id
        }
        vm.newTheme(data).then(response => {
          if (response._id) {
            vm.theme.description = null
            vm.theme.issue = null
            vm.allThemes.push(response)
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Nuevo tema creado',
              closeable: true,
              duration: 5000
            })
          }
        }, error => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Debe rellenar todos los campos',
          closeable: true,
          duration: 5000
        })
      }
    },
    loadLists(id) {
      const vm = this
      const loading = vm.$toast.loading('Cargando compromisos...')
      const userLeader = vm.$store.state.auth.user.id
      vm.listCommitments(userLeader).then(response => {
        vm.allCommitments = response.commitments
      }, error => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
      vm.listProblems(userLeader).then(response => {
        vm.listProblemsAndOport = response.problems
      }, error => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
      vm.listThemes(id).then(response => {
        vm.allThemes = response.themes
      }, error => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    removeCommit(array, id) {
      const vm = this;
      if (array === 'nuevos') {
        vm.deleteCommitment(id).then(result => {
          if (result) {
            vm.allCommitments.nuevos = vm.allCommitments.nuevos.filter(commitment => {
              return commitment.id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
         vm.deleteCommitment(id).then(result => {
          if (result) {
            vm.allCommitments.pendientes = vm.allCommitments.pendientes.filter(commitment => {
              return commitment.id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Compromiso eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      }
    },
     openObjectiveCommentBox(item) {
      const vm = this;
      vm.objective = item
      vm.objective.comments = vm.objective.comments.reverse()
      vm.comment = ''
      vm.drawer_objective = true
    },
    addObjectiveComment(id) {
      const vm = this;
      const data = {
        comment: {
          text: vm.comment,
          user: vm.$store.state.auth.user.name,
          date: Date.now()
        },
        id,
      }
      if (vm.comment != '') {
        vm.addComment(data).then(response => {
          vm.objective.comments = response.reverse()
        })
      }
    },
    removeTheme(id) {
      const vm = this;
      vm.deleteTheme(id).then(result => {
        if (result) {
          vm.allThemes = vm.allThemes.filter(theme => {
            return theme._id !== id
          })
          vm.$notify({
            type: 'success',
            title: 'Notificación',
              content: 'Tema eliminado',
            closeable: true,
            duration: 5000
          })
        }
      })
    },
    removeProblem(array, id) {
      const vm = this;
      if (array === 'nuevos') {
        vm.deleteProblem(id).then(result => {
          if (result) {
            vm.listProblemsAndOport.nuevos = vm.listProblemsAndOport.nuevos.filter(problem => {
              return problem._id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Problema/oportunidad eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      } else {
         vm.deleteProblem(id).then(result => {
          if (result) {
            vm.listProblemsAndOport.pendientes = vm.listProblemsAndOport.pendientes.filter(problem => {
              return problem.id !== id
            })
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Promesa/oportunidad eliminado',
              closeable: true,
              duration: 5000
            })
          }
        })
      }
    },
    closeDDD() {
      const vm = this;
      const assistants = vm.colaboradores.map(colaborador => {
        return { _id: colaborador.id, name: colaborador.name }
      })
      const data = {
        id: vm.$route.params.id,
        assistants,
        userLeader: vm.$store.state.auth.user.id
      }
      vm.finishMeeting(data).then(result => {
        const loading = vm.$toast.loading('Cerrando dialogo de desempeño...')
        if (result.success) {
          setTimeout(() => {
            this.$router.push('/dialogo-desempeno/id')
            loading.hide()
          }, 3000)
          vm.$notify({
            type: 'success',
            title: 'Notificación',
            content: 'Dialogo de desempeño cerrado',
            closeable: true,
            duration: 5000
          })
        }
      }).catch(e => {
        loading.hide()
        vm.$notify({  
          type: 'error',
          title: 'Error',
          content: 'Error al cerrar dialogo de desempeño',
          closeable: true,
          duration: 5000
        })
      })
    },
    customKpiLabel(objective) {
      let label = ''
      if (objective.open) {
        if (objective.business_type) {
          label = `${objective.business_type.name} Libre`;
        } else {
          label = 'Libre';
        }
      } else {
        label = objective.kpi.name;
      }
      return label;
    },
    getComments(id, type) {
      const vm = this
      vm.commenting = id
      vm.type = type
      switch (vm.type) {
        case 'commitment':
          vm.getCommentsFromCommitment(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
        case 'problem':
          vm.getCommentsFromProblem(vm.commenting).then(response => {
            vm.comments = response.reverse()
          })
        break
      }
    },
    createComment(comment) {
      if (comment) {
        const vm = this
        const data = {
          description: comment,
          _id: vm.commenting,
          user: vm.$store.state.auth.user.name
        }
        switch (vm.type) {
          case 'commitment':
            vm.addCommentToCommitment(data).then(response => {
              vm.comments = response.reverse()
            })
          break
          case 'problem':
            vm.addCommentToProblem(data).then(response => {
              vm.comments = response.reverse()
            })
          break
        }
        vm.comment = ''
      }
    },
    openCloseModal(id, type) {
      const vm = this;
      vm.getComments(id, type)
      vm.drawer = true
      vm.closing = id
      vm.type = type;
    },
    closeItem() {
      const vm = this;
      if (vm.cumplimiento === '') {
        vm.$notify({  
          type: 'danger',
          title: 'Error',
          content: 'Tiene que elegir si fue completado',
          closeable: true,
          duration: 5000
        })  
      } else {      
        const data = {
          accomplished: vm.cumplimiento,
          id: vm.closing
        }
        switch (vm.type) {
          case 'commitment':
            vm.closeCommitment(data).then(result => {
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de compromiso ejecutado',
                  closeable: true,
                  duration: 5000
                })  
                vm.allCommitments.pendientes = vm.allCommitments.pendientes.filter(commitment => {
                  return commitment._id !== result._id
                })
              }
            })
            break
          case 'problem':
            const commentObj = {
              description: vm.comment,
              user: vm.$store.state.auth.user.name,
              creation_date: moment()
            }
            data.comment = commentObj;
            vm.closeProblem(data).then(result => { 
              if (result._id) {
                vm.$notify({  
                  type: 'success',
                  title: 'Notification',
                  content: 'Cierre de problema ejecutado',
                  closeable: true,
                  duration: 5000
                })  
                vm.listProblemsAndOport.pendientes = vm.listProblemsAndOport.pendientes.filter(problem => {
                  return problem._id !== result._id
                })
              }
            })
            break
        }
        vm.drawer = false
        vm.cumplimiento = ''
      }
    },
    isTodos(commitment) {
      const vm = this;
      let isAll = false
      for (let user of commitment.user) {
        if (user.name == 'Todos') {
          isAll = true;
          break;
        }
      }

      if (isAll) {
        vm.commitment.user = [];
        for (let u of this.dddColaboradores) {
          if (u.name != 'Todos') {
            commitment.user.push(u)
          }
        }
      }
    }
  },
  mounted() {
    const vm = this
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.loadMeeting(vm.$route.params.id)
    vm.loadLists(vm.$route.params.id)
    vm.$store.getters['user/myCollabs'] ? vm.colaboradores = vm.$store.getters['user/myCollabs'] : vm.loadCollabs(vm.user.id)
  }
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/dialogo-desempeno-ejecutar.vue